import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import LoginPassword                                from "../../../domain/authentication/LoginPassword";
import MenuType                                     from "../../../domain/menu/MenuType";
import Staff                                        from "../../../domain/staff/Staff";
import StaffRepository                              from "../../../domain/staff/StaffRepository";
import { ResKaState }                               from "../../../index";
import StaffDataSource                              from "../../../infrastructure/datasource/staff/StaffDataSource";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import BottomSection                                from "../../components/common/layout/BottomSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import StaffRegisterForm                            from "../../components/staff/StaffRegisterForm";
import StaffSaveButton                              from "../../components/staff/StaffSaveButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  staffRepository: StaffRepository;
}

interface State extends BaseState {
  password: LoginPassword;
}

class StaffRegisterContainer extends ResKaBaseContainer<Props, State> {
  constructor(props: Props) {
    const state = {
      menuType: MenuType.SETTING,
      headerTitle: "スタッフ追加",
      password: new LoginPassword(""),
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
    this.props.staffRepository.setStaff(new Staff());
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "スタッフ一覧",
                path: "/staffs"
              },
              {
                title: "スタッフ追加",
                path: "/staff/register"
              },
            ]
          }/>
        </TopSection>

        <TopSection>
          <StaffSaveButton password={ this.state.password }/>
          <BackHistoryButton path="/staffs"/>
        </TopSection>

        <StaffRegisterForm
          setPassword={ value => this.setState({password: value}) }
        />

        <BottomSection>
          <StaffSaveButton password={ this.state.password }/>
          <BackHistoryButton path="/staffs"/>
        </BottomSection>
      </>
    );
  }

}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus
});

const mapDispatchToProps = (dispatch) => ({
  staffRepository: new StaffDataSource(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StaffRegisterContainer);
